export const environment = {
  production: true,
  BASE_DOMAIN:'https://ftl-dev.apollosupplychain.com/',
  AUTH_URL:'https://auth-dev.apollosupplychain.com/auth-service-common/',
  // AUTH_URL:'https://ftl-dev.apollosupplychain.com/ftl-auth-service',
  New_BASE_DOMAIN:'https://ftl-dev.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://ftl-dev.apollosupplychain.com/',
  WebsocketUrl: 'wss://ftl-dev.apollosupplychain.com/websocket-service/ws/notifications'
};
